import { useState, useEffect } from 'react';
import { loadDateLocaleFromSystem } from '../services/dateLocaleService';

/**
 * Fetches the country code from system settings for date picker blocking
 * (weekends and public holidays). Uses AllowAnonymous endpoint.
 */
export function useDateLocale(): string {
  const [country, setCountry] = useState<string>('ZA');

  useEffect(() => {
    loadDateLocaleFromSystem().then((d) => setCountry(d.country));
  }, []);

  return country;
}
